import axios from '@/resources/libs/axios'

export default {
    getDashboardMetrics(data) {
        return axios.get(`/gei/document-expiration-config/calculate-metrics`, {params: data})
    },
    generateInformDocumentExpirationExcel(data) {
        return axios.post(`/gei/document-expiration-config/export-excel`, data, {responseType: 'blob'})
    },
}